"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * MyBuy Backend API
 * ## Release Notes  ### v0.0.1  Work in progress
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.StoredPaymentDataDirectDebitCurrentToJSON = exports.StoredPaymentDataDirectDebitCurrentFromJSONTyped = exports.StoredPaymentDataDirectDebitCurrentFromJSON = void 0;
function StoredPaymentDataDirectDebitCurrentFromJSON(json) {
    return StoredPaymentDataDirectDebitCurrentFromJSONTyped(json, false);
}
exports.StoredPaymentDataDirectDebitCurrentFromJSON = StoredPaymentDataDirectDebitCurrentFromJSON;
function StoredPaymentDataDirectDebitCurrentFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'iban': json['iban'],
        'bic': json['bic'],
    };
}
exports.StoredPaymentDataDirectDebitCurrentFromJSONTyped = StoredPaymentDataDirectDebitCurrentFromJSONTyped;
function StoredPaymentDataDirectDebitCurrentToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'iban': value.iban,
        'bic': value.bic,
    };
}
exports.StoredPaymentDataDirectDebitCurrentToJSON = StoredPaymentDataDirectDebitCurrentToJSON;
//# sourceMappingURL=StoredPaymentDataDirectDebitCurrent.js.map